    // Filter the buttons by text input //update
    const HIDDEN_MAX = 6;
    
    const topParent = document?.querySelector(
      ".help-center-searchbar-section"
    );
    const filterInput = topParent?.querySelector(
      ".help-center-input-searchbar"
    );

    const buttons = topParent?.querySelectorAll(
      ".help-center-button-search-container .help-center-button-link"
    );

    const viewButton = topParent?.querySelector(
      "#help-center-view--more"
    );
    //Get text user placed on button
    const textOnButton = viewButton?.textContent ?? "";

    let isShowingMax = true;
    function init(){
      viewButton.textContent = `${textOnButton} [+]`;
    }
    
    if(topParent){
      document.addEventListener('DOMContentLoaded', init);
    }

    function toggleShowMe() {
      // Show button and buttons tags
      const elementHasShowHidden = topParent?.querySelectorAll(
        "[data-button-show-more]"
      );
      //Controls the visibilty of the Show More button
      if (elementHasShowHidden?.length ?? 0 > 0) {
        viewButton ? (viewButton.style.display = "block") : "";
      } else {
        viewButton ? (viewButton.style.display = "none") : "";
      }
    }

    const filterInputData = () => {
      const filterText = filterInput ? filterInput.value.toLowerCase() : "";
      let foundMatchCount = 0;
      buttons?.forEach((button) => {
        const buttonText = button.textContent?.toLowerCase();
        const parentButtonWrapper = button.parentElement;
        if (parentButtonWrapper) {
          // Remove tag after each search
          parentButtonWrapper.removeAttribute("data-button-show-more");
          // Filters the shown buttons //Tag is for blocks hidden by "show me button"
          if (buttonText?.includes(filterText)) {
            let endDisplay = "block";
            if (foundMatchCount >= HIDDEN_MAX) {
              if (isShowingMax) {
                endDisplay = "none";
              }
              parentButtonWrapper.setAttribute("data-button-show-more", "true");
            }
            parentButtonWrapper.style.display = endDisplay;
            foundMatchCount++;
          } else {
            parentButtonWrapper.style.display = "none";
          }
        }
      });
      toggleShowMe();
    }

    filterInput?.addEventListener("input", filterInputData);
    // Call once to add tags
    filterInputData();
    // ===============
    // Controls functionality of Show More button
    viewButton?.addEventListener("click", () => {
      // Show button and buttons tags
      const elementHasShowHidden = topParent?.querySelectorAll(
        "[data-button-show-more]"
      );
      
      if (isShowingMax) {
        // Click to Show More buttons
        isShowingMax = false;
        elementHasShowHidden?.forEach((el) => (el.style.display = "block"));
        viewButton.textContent = `${textOnButton} [-]`;
      } else {
        // Click to Show Less buttons
        isShowingMax = true;
        elementHasShowHidden?.forEach((el) => (el.style.display = "none"));
        viewButton.textContent = `${textOnButton} [+]`;
      }
    });